import { render, staticRenderFns } from "./ProductChannelLinkCardCmp.vue?vue&type=template&id=eae5323a&scoped=true&"
import script from "./ProductChannelLinkCardCmp.vue?vue&type=script&lang=js&"
export * from "./ProductChannelLinkCardCmp.vue?vue&type=script&lang=js&"
import style0 from "./ProductChannelLinkCardCmp.vue?vue&type=style&index=0&id=eae5323a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae5323a",
  null
  
)

export default component.exports